import request from '@/utils/request'

// 供应商查询自己的商品库存列表
export function supplierGoodsInventoryList (query) {
  return request({
    url: '/wms/supplier/inventory/',
    method: 'get',
    params: query
  })
}
